<template>
    <div v-if="sapProfile==true" style="overflow-x:auto !important">
        <div>
            <div style="overflow:auto">
                <div class="ZAfont_family ZAfont_size" style="margin-bottom:30px">
                    <div v-if="encoderType!=null">
                        <span class="my_color_00338e my_font-weight_600">{{$t('3075')}}:</span>
                        <span> {{encoderType}}</span>
                    </div>
                    <hr />
                </div>
                <div v-if="encoderConnectionInformation==null" class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3449')}} {{$t('3075')}}</div>
                <div v-if="encoderConnectionInformation!=null" class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3436')}}</div>
                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                    <div>
                        <div class="ZAfont_family ZAfont_size">{{$t('3450')}}:</div>
                    </div>
                    <div v-if="encoderCableDeliverSelection.length==0 || encoderCableDeliverSelection.length>4">
                        <select v-model="selectedEncoderCableDeliver" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: selectedEncoderCableDeliver==null, my_input_background_color_at_validInput:selectedEncoderCableDeliver!=null}">
                            <option value="null" hidden>{{$t('3174')}}</option>
                            <option value="" hidden>{{$t('3174')}}</option>
                            <option v-for="encoderCableDeliver in encoderCableDeliverSelection" v-bind:value="encoderCableDeliver">
                                {{encoderCableDeliver.text.useTextKey?$t(encoderCableDeliver.text.textKey):encoderCableDeliver.text.textUI}}
                            </option>
                        </select>
                    </div>
                    <div v-if="encoderCableDeliverSelection.length>0 && encoderCableDeliverSelection.length<=4">
                        <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: selectedEncoderCableDeliver==null, my_input_background_color_at_validInput:selectedEncoderCableDeliver!=null}">
                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                <li v-for="encoderCableDeliver in encoderCableDeliverSelection">
                                    <input type="checkbox" @input="change_Selected_atElementOf_encoderCableDeliver(encoderCableDeliver)" v-bind:checked="encoderCableDeliver.selected" v-bind:disabled="encoderCableDeliver.selected" />
                                    <span style="margin-left:10px">{{encoderCableDeliver.text.useTextKey?$t(encoderCableDeliver.text.textKey):encoderCableDeliver.text.textUI}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="encoderCablesShowDetails==true">
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3431')}}:</div>
                        </div>
                        <div v-if="encoderCableLengthSelection.length==0 || encoderCableLengthSelection.length>4">
                            <select v-model="selectedEncoderCableLength" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: encoderCableLengthSelection.length >0 && selectedEncoderCableLength==null, my_input_background_color_at_validInput: encoderCableLengthSelection.length == 0 ||selectedEncoderCableLength!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="encoderCableLength in encoderCableLengthSelection" v-bind:value="encoderCableLength">{{ValueDecimalSeparator(encoderCableLength.value)}}</option>
                            </select>
                        </div>
                        <div v-if="encoderCableLengthSelection.length>0 && encoderCableLengthSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: encoderCableLengthSelection.length >0 && selectedEncoderCableLength==null, my_input_background_color_at_validInput: encoderCableLengthSelection.length == 0 ||selectedEncoderCableLength!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="encoderCableLength in encoderCableLengthSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_encoderCableLength(encoderCableLength)" v-bind:checked="encoderCableLength.selected" v-bind:disabled="encoderCableLength.selected" />
                                        <span style="margin-left:10px">{{ValueDecimalSeparator(encoderCableLength.value)}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3426')}}:</div>
                        </div>
                        <div v-if="encoderCableTypeOfConnectionOnComponentSideSelection.length==0 || encoderCableTypeOfConnectionOnComponentSideSelection.length>4">
                            <select v-model="selectedEncoderCableTypeOfConnectionOnComponentSide" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: encoderCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedEncoderCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: encoderCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedEncoderCableTypeOfConnectionOnComponentSide!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="encoderCableTypeOfConnectionOnComponentSide in encoderCableTypeOfConnectionOnComponentSideSelection" v-bind:value="encoderCableTypeOfConnectionOnComponentSide">
                                    {{encoderCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(encoderCableTypeOfConnectionOnComponentSide.text.textKey):encoderCableTypeOfConnectionOnComponentSide.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="encoderCableTypeOfConnectionOnComponentSideSelection.length>0 && encoderCableTypeOfConnectionOnComponentSideSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: encoderCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedEncoderCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: encoderCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedEncoderCableTypeOfConnectionOnComponentSide!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="encoderCableTypeOfConnectionOnComponentSide in encoderCableTypeOfConnectionOnComponentSideSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_encoderCableTypeOfConnectionOnComponentSide(encoderCableTypeOfConnectionOnComponentSide)" v-bind:checked="encoderCableTypeOfConnectionOnComponentSide.selected" v-bind:disabled="encoderCableTypeOfConnectionOnComponentSide.selected" />
                                        <span style="margin-left:10px">{{encoderCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(encoderCableTypeOfConnectionOnComponentSide.text.textKey):encoderCableTypeOfConnectionOnComponentSide.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3422')}}:</div>
                        </div>
                        <div v-if="encoderCableSpecificationSelection.length==0 || encoderCableSpecificationSelection.length>4">
                            <select v-model="selectedEncoderCableSpecification" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: encoderCableSpecificationSelection.length >0 && selectedEncoderCableSpecification==null, my_input_background_color_at_validInput: encoderCableSpecificationSelection.length == 0 ||selectedEncoderCableSpecification!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="encoderCableSpecification in encoderCableDeliverSelection" v-bind:value="encoderCableSpecification">
                                    {{encoderCableSpecification.text.useTextKey?$t(encoderCableSpecification.text.textKey):encoderCableSpecification.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="encoderCableSpecificationSelection.length>0 && encoderCableSpecificationSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: encoderCableSpecificationSelection.length >0 && selectedEncoderCableSpecification==null, my_input_background_color_at_validInput: encoderCableSpecificationSelection.length == 0 ||selectedEncoderCableSpecification!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="encoderCableSpecification in encoderCableSpecificationSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_encoderCableSpecification(encoderCableSpecification)" v-bind:checked="encoderCableSpecification.selected" v-bind:disabled="encoderCableSpecification.selected" />
                                        <span style="margin-left:10px">{{encoderCableSpecification.text.useTextKey?$t(encoderCableSpecification.text.textKey):encoderCableSpecification.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3466')}}:</div>
                        </div>
                        <div v-if="encoderCableNumberOfWiresAndCrossSectionSelection.length==0 || encoderCableNumberOfWiresAndCrossSectionSelection.length>4">
                            <select v-model="selectedEncoderCableNumberOfWiresAndCrossSection" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: encoderCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedEncoderCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: encoderCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedEncoderCableNumberOfWiresAndCrossSection!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="encoderCableNumberOfWiresAndCrossSection in encoderCableDeliverSelection" v-bind:value="encoderCableNumberOfWiresAndCrossSection">
                                    {{encoderCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(encoderCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                </option>
                            </select>
                        </div>
                        <div v-if="encoderCableNumberOfWiresAndCrossSectionSelection.length>0 && encoderCableNumberOfWiresAndCrossSectionSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: encoderCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedEncoderCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: encoderCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedEncoderCableNumberOfWiresAndCrossSection!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="encoderCableNumberOfWiresAndCrossSection in encoderCableNumberOfWiresAndCrossSectionSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_encoderCableNumberOfWiresAndCrossSection(encoderCableNumberOfWiresAndCrossSection)" v-bind:checked="encoderCableNumberOfWiresAndCrossSection.selected" v-bind:disabled="encoderCableNumberOfWiresAndCrossSection.selected" />
                                        {{encoderCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(encoderCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3427')}}:</div>
                        </div>
                        <div v-if="encoderCableBlockNumberSelection!=null&&encoderCableBlockNumberSelection.length>0">
                            <select v-model="selectedEncoderCableBlockNumber" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: encoderCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedEncoderCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: encoderCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedEncoderCableNumberOfWiresAndCrossSection!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="cable in encoderCableBlockNumberSelection" v-bind:value="cable">
                                    {{cable.blockNumber}} | {{cable.typeDesignation.useTextKey?$t(cable.typeDesignation.textKey):cable.typeDesignation.textUI}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div v-if="encoderConnectionInformation!=null" class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                    <div>
                        <div class="ZAfont_family ZAfont_size">{{$t('3428')}}:</div>
                    </div>
                    <div>
                        <select v-model="selectedEncoderConnection" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: encoderCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedEncoderCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: encoderCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedEncoderCableNumberOfWiresAndCrossSection!=null}">
                            <option value="null" hidden>{{$t('3174')}}</option>
                            <option value="" hidden>{{$t('3174')}}</option>
                            <option v-for="encoderConnection in encoderConnectionInformation" v-bind:value="encoderConnection">
                                {{encoderConnection.blockNumber}} | {{ValueDecimalSeparator(encoderConnection.length)}} m | {{encoderConnection.typeOfConnection}}
                            </option>
                        </select>
                    </div>

                    <!--<div>
                        <span>{{encoderConnectionInformation.blockNumber}}</span>
                        <span v-if="encoderConnectionInformation.length!=null"> | {{ValueDecimalSeparator(encoderConnectionInformation.length)}} m</span>
                    </div>-->
                </div>
                <hr />
            </div>
            <div style="overflow:auto">
                <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3437')}}</div>
                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                    <div>
                        <div class="ZAfont_family ZAfont_size">{{$t('3450')}}:</div>
                    </div>
                    <div v-if="motorCableDeliverSelection.length==0 || motorCableDeliverSelection.length>4">
                        <select v-model="selectedMotorCableDeliver" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput:selectedMotorCableDeliver==null, my_input_background_color_at_validInput:selectedMotorCableDeliver!=null}">
                            <option value="null" hidden>{{$t('3174')}}</option>
                            <option value="" hidden>{{$t('3174')}}</option>
                            <option v-for="motorCableDeliver in motorCableDeliverSelection" v-bind:value="motorCableDeliver">
                                {{motorCableDeliver.text.useTextKey?$t(motorCableDeliver.text.textKey):motorCableDeliver.text.textUI}}
                            </option>
                        </select>
                    </div>
                    <div v-if="motorCableDeliverSelection.length>0 && motorCableDeliverSelection.length<=4">
                        <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput:selectedMotorCableDeliver==null, my_input_background_color_at_validInput:selectedMotorCableDeliver!=null}">
                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                <li v-for="motorCableDeliver in motorCableDeliverSelection">
                                    <input type="checkbox" @input="change_Selected_atElementOf_motorCableDeliver(motorCableDeliver)" v-bind:checked="motorCableDeliver.selected" v-bind:disabled="motorCableDeliver.selected" />
                                    <span style="margin-left:10px">{{motorCableDeliver.text.useTextKey?$t(motorCableDeliver.text.textKey):motorCableDeliver.text.textUI}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="motorCablesShowDetails==true">
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3431')}}:</div>
                        </div>
                        <div v-if="motorCableLengthSelection.length==0 || motorCableLengthSelection.length>4">
                            <select v-model="selectedMotorCableLength" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: motorCableLengthSelection.length >0 && selectedMotorCableLength==null, my_input_background_color_at_validInput: motorCableLengthSelection.length == 0 ||selectedMotorCableLength!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="motorCableLength in motorCableLengthSelection" v-bind:value="motorCableLength">{{ValueDecimalSeparator(motorCableLength.value)}}</option>
                            </select>
                        </div>
                        <div v-if="motorCableLengthSelection.length>0 && motorCableLengthSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: motorCableLengthSelection.length >0 && selectedMotorCableLength==null, my_input_background_color_at_validInput: motorCableLengthSelection.length == 0 ||selectedMotorCableLength!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="motorCableLength in motorCableLengthSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_motorCableLength(motorCableLength)" v-bind:checked="motorCableLength.selected" v-bind:disabled="motorCableLength.selected" />
                                        <span style="margin-left:10px">{{ValueDecimalSeparator(motorCableLength.value)}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3426')}}:</div>
                        </div>
                        <div v-if="motorCableTypeOfConnectionOnComponentSideSelection.length==0 || motorCableTypeOfConnectionOnComponentSideSelection.length>4">
                            <select v-model="selectedMotorCableTypeOfConnectionOnComponentSide" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: motorCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedMotorCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: motorCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedMotorCableTypeOfConnectionOnComponentSide!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="motorCableTypeOfConnectionOnComponentSide in motorCableTypeOfConnectionOnComponentSideSelection" v-bind:value="motorCableTypeOfConnectionOnComponentSide">
                                    {{motorCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(motorCableTypeOfConnectionOnComponentSide.text.textKey):motorCableTypeOfConnectionOnComponentSide.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="motorCableTypeOfConnectionOnComponentSideSelection.length>0 && motorCableTypeOfConnectionOnComponentSideSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: motorCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedMotorCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: motorCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedMotorCableTypeOfConnectionOnComponentSide!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="motorCableTypeOfConnectionOnComponentSide in motorCableTypeOfConnectionOnComponentSideSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_motorCableTypeOfConnectionOnComponentSide(motorCableTypeOfConnectionOnComponentSide)" v-bind:checked="motorCableTypeOfConnectionOnComponentSide.selected" v-bind:disabled="motorCableTypeOfConnectionOnComponentSide.selected" />
                                        <span style="margin-left:10px">{{motorCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(motorCableTypeOfConnectionOnComponentSide.text.textKey):motorCableTypeOfConnectionOnComponentSide.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3422')}}:</div>
                        </div>
                        <div v-if="motorCableSpecificationSelection.length==0 || motorCableSpecificationSelection.length>4">
                            <select v-model="selectedMotorCableSpecification" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: motorCableSpecificationSelection.length >0 && selectedMotorCableSpecification==null, my_input_background_color_at_validInput: motorCableSpecificationSelection.length == 0 ||selectedMotorCableSpecification!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="motorCableSpecification in motorCableSpecificationSelection" v-bind:value="motorCableSpecification">
                                    {{motorCableSpecification.text.useTextKey?$t(motorCableSpecification.text.textKey):motorCableSpecification.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="motorCableSpecificationSelection.length>0 && motorCableSpecificationSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: motorCableSpecificationSelection.length >0 && selectedMotorCableSpecification==null, my_input_background_color_at_validInput: motorCableSpecificationSelection.length == 0 ||selectedMotorCableSpecification!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="motorCableSpecification in motorCableSpecificationSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_motorCableSpecification(motorCableSpecification)" v-bind:checked="motorCableSpecification.selected" v-bind:disabled="motorCableSpecification.selected" />
                                        <span style="margin-left:10px">{{motorCableSpecification.text.useTextKey?$t(motorCableSpecification.text.textKey):motorCableSpecification.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3466')}}:</div>
                        </div>
                        <div v-if="motorCableNumberOfWiresAndCrossSectionSelection.length==0 || motorCableNumberOfWiresAndCrossSectionSelection.length>4">
                            <select v-model="selectedMotorCableNumberOfWiresAndCrossSection" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: motorCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedMotorCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: motorCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedMotorCableNumberOfWiresAndCrossSection!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="motorCableNumberOfWiresAndCrossSection in motorCableDeliverSelection" v-bind:value="motorCableNumberOfWiresAndCrossSection">
                                    {{motorCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(motorCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                </option>
                            </select>
                        </div>
                        <div v-if="motorCableNumberOfWiresAndCrossSectionSelection.length>0 && motorCableNumberOfWiresAndCrossSectionSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: motorCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedMotorCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: motorCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedMotorCableNumberOfWiresAndCrossSection!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="motorCableNumberOfWiresAndCrossSection in motorCableNumberOfWiresAndCrossSectionSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_motorCableNumberOfWiresAndCrossSection(motorCableNumberOfWiresAndCrossSection)" v-bind:checked="motorCableNumberOfWiresAndCrossSection.selected" v-bind:disabled="motorCableNumberOfWiresAndCrossSection.selected" />
                                        {{motorCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(motorCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3427')}}:</div>
                        </div>
                        <div v-if="motorCableBlockNumberSelection!=null&&motorCableBlockNumberSelection.length>0">
                            <select v-model="selectedMotorCableBlockNumber" class="my_select" style="width:100%">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="cable in motorCableBlockNumberSelection" v-bind:value="cable">
                                    {{cable.blockNumber}} | {{cable.typeDesignation.useTextKey?$t(cable.typeDesignation.textKey):cable.typeDesignation.textUI}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
            <div style="overflow:auto">
                <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3438')}}</div>
                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                    <div>
                        <div class="ZAfont_family ZAfont_size">{{$t('3450')}}:</div>
                    </div>
                    <div v-if="motorProtectionCableDeliverSelection.length==0 || motorProtectionCableDeliverSelection.length>4">
                        <select v-model="selectedMotorProtectionCableDeliver" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput:selectedMotorProtectionCableDeliver==null, my_input_background_color_at_validInput:selectedMotorProtectionCableDeliver!=null}">
                            <option value="null" hidden>{{$t('3174')}}</option>
                            <option value="" hidden>{{$t('3174')}}</option>
                            <option v-for="motorProtectionCableDeliver in motorProtectionCableDeliverSelection" v-bind:value="motorProtectionCableDeliver">
                                {{motorProtectionCableDeliver.text.useTextKey?$t(motorProtectionCableDeliver.text.textKey):motorProtectionCableDeliver.text.textUI}}
                            </option>
                        </select>
                    </div>
                    <div v-if="motorProtectionCableDeliverSelection.length>0 && motorProtectionCableDeliverSelection.length<=4">
                        <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput:selectedMotorProtectionCableDeliver==null, my_input_background_color_at_validInput:selectedMotorProtectionCableDeliver!=null}">
                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                <li v-for="motorProtectionCableDeliver in motorProtectionCableDeliverSelection">
                                    <input type="checkbox" @input="change_Selected_atElementOf_motorProtectionCableDeliver(motorProtectionCableDeliver)" v-bind:checked="motorProtectionCableDeliver.selected" v-bind:disabled="motorProtectionCableDeliver.selected" />
                                    <span style="margin-left:10px">{{motorProtectionCableDeliver.text.useTextKey?$t(motorProtectionCableDeliver.text.textKey):motorProtectionCableDeliver.text.textUI}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="motorProtectionCablesShowDetails==true">
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3431')}}:</div>
                        </div>
                        <div v-if="motorProtectionCableLengthSelection.length==0 || motorProtectionCableLengthSelection.length>4">
                            <select v-model="selectedMotorProtectionCableLength" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: motorProtectionCableLengthSelection.length >0 && selectedMotorProtectionCableLength==null, my_input_background_color_at_validInput: motorProtectionCableLengthSelection.length == 0 ||selectedMotorProtectionCableLength!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="motorProtectionCableLength in motorProtectionCableLengthSelection" v-bind:value="motorProtectionCableLength">{{ValueDecimalSeparator(motorProtectionCableLength.value)}}</option>
                            </select>
                        </div>
                        <div v-if="motorProtectionCableLengthSelection.length>0 && motorProtectionCableLengthSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: motorProtectionCableLengthSelection.length >0 && selectedMotorProtectionCableLength==null, my_input_background_color_at_validInput: motorProtectionCableLengthSelection.length == 0 ||selectedMotorProtectionCableLength!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="motorProtectionCableLength in motorProtectionCableLengthSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_motorProtectionCableLength(motorProtectionCableLength)" v-bind:checked="motorProtectionCableLength.selected" v-bind:disabled="motorProtectionCableLength.selected" />
                                        <span style="margin-left:10px">{{ValueDecimalSeparator(motorProtectionCableLength.value)}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3426')}}:</div>
                        </div>
                        <div v-if="motorProtectionCableTypeOfConnectionOnComponentSideSelection.length==0 || motorProtectionCableTypeOfConnectionOnComponentSideSelection.length>4">
                            <select v-model="selectedMotorProtectionCableTypeOfConnectionOnComponentSide" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: motorProtectionCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedMotorProtectionCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: motorProtectionCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedMotorProtectionCableTypeOfConnectionOnComponentSide!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="motorProtectionCableTypeOfConnectionOnComponentSide in motorProtectionCableTypeOfConnectionOnComponentSideSelection" v-bind:value="motorProtectionCableTypeOfConnectionOnComponentSide">
                                    {{motorProtectionCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(motorProtectionCableTypeOfConnectionOnComponentSide.text.textKey):motorProtectionCableTypeOfConnectionOnComponentSide.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="motorProtectionCableTypeOfConnectionOnComponentSideSelection.length>0 && motorProtectionCableTypeOfConnectionOnComponentSideSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: motorProtectionCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedMotorProtectionCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: motorProtectionCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedMotorProtectionCableTypeOfConnectionOnComponentSide!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="motorProtectionCableTypeOfConnectionOnComponentSide in motorProtectionCableTypeOfConnectionOnComponentSideSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_motorProtectionCableTypeOfConnectionOnComponentSide(motorProtectionCableTypeOfConnectionOnComponentSide)" v-bind:checked="motorProtectionCableTypeOfConnectionOnComponentSide.selected" v-bind:disabled="motorProtectionCableTypeOfConnectionOnComponentSide.selected" />
                                        <span style="margin-left:10px">{{motorProtectionCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(motorProtectionCableTypeOfConnectionOnComponentSide.text.textKey):motorProtectionCableTypeOfConnectionOnComponentSide.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3422')}}:</div>
                        </div>
                        <div v-if="motorProtectionCableSpecificationSelection.length==0 || motorProtectionCableSpecificationSelection.length>4">
                            <select v-model="selectedMotorProtectionCableSpecification" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: motorProtectionCableSpecificationSelection.length >0 && selectedMotorProtectionCableSpecification==null, my_input_background_color_at_validInput: motorProtectionCableSpecificationSelection.length == 0 ||selectedMotorProtectionCableSpecification!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="motorProtectionCableSpecification in motorProtectionCableDeliverSelection" v-bind:value="motorProtectionCableSpecification">
                                    {{motorProtectionCableSpecification.text.useTextKey?$t(motorProtectionCableSpecification.text.textKey):motorProtectionCableSpecification.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="motorProtectionCableSpecificationSelection.length>0 && motorProtectionCableSpecificationSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: motorProtectionCableSpecificationSelection.length >0 && selectedMotorProtectionCableSpecification==null, my_input_background_color_at_validInput: motorProtectionCableSpecificationSelection.length == 0 ||selectedMotorProtectionCableSpecification!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="motorProtectionCableSpecification in motorProtectionCableSpecificationSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_motorProtectionCableSpecification(motorProtectionCableSpecification)" v-bind:checked="motorProtectionCableSpecification.selected" v-bind:disabled="motorProtectionCableSpecification.selected" />
                                        <span style="margin-left:10px">{{motorProtectionCableSpecification.text.useTextKey?$t(motorProtectionCableSpecification.text.textKey):motorProtectionCableSpecification.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3466')}}:</div>
                        </div>
                        <div v-if="motorProtectionCableNumberOfWiresAndCrossSectionSelection.length==0 || motorProtectionCableNumberOfWiresAndCrossSectionSelection.length>4">
                            <select v-model="selectedMotorProtectionCableNumberOfWiresAndCrossSection" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: motorProtectionCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedMotorProtectionCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: motorProtectionCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedMotorProtectionCableNumberOfWiresAndCrossSection!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="motorProtectionCableNumberOfWiresAndCrossSection in motorProtectionCableDeliverSelection" v-bind:value="motorProtectionCableNumberOfWiresAndCrossSection">
                                    {{motorProtectionCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(motorProtectionCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                </option>
                            </select>
                        </div>
                        <div v-if="motorProtectionCableNumberOfWiresAndCrossSectionSelection.length>0 && motorProtectionCableNumberOfWiresAndCrossSectionSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: motorProtectionCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedMotorProtectionCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: motorProtectionCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedMotorProtectionCableNumberOfWiresAndCrossSection!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="motorProtectionCableNumberOfWiresAndCrossSection in motorProtectionCableNumberOfWiresAndCrossSectionSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_motorProtectionNumberOfWiresAndCrossSection(motorProtectionCableNumberOfWiresAndCrossSection)" v-bind:checked="motorProtectionCableNumberOfWiresAndCrossSection.selected" v-bind:disabled="motorProtectionCableNumberOfWiresAndCrossSection.selected" />
                                        {{motorProtectionCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(motorProtectionCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3427')}}:</div>
                        </div>
                        <div v-if="motorProtectionCableBlockNumberSelection!=null&&motorProtectionCableBlockNumberSelection.length>0">
                            <select v-model="selectedMotorProtectionCableBlockNumber" class="my_select" style="width:100%">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="cable in motorProtectionCableBlockNumberSelection" v-bind:value="cable">
                                    {{cable.blockNumber}} | {{cable.typeDesignation.useTextKey?$t(cable.typeDesignation.textKey):cable.typeDesignation.textUI}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
            <div style="overflow:auto">
                <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3439')}}</div>
                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                    <div>
                        <div class="ZAfont_family ZAfont_size">{{$t('3450')}}:</div>
                    </div>
                    <div v-if="brakeCableDeliverSelection.length==0 || brakeCableDeliverSelection.length>4">
                        <select v-model="selectedBrakeCableDeliver" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: brakeCableDeliverSelection.length >0 && selectedBrakeCableDeliver==null, my_input_background_color_at_validInput: brakeCableDeliverSelection.length == 0 ||selectedBrakeCableDeliver!=null}">
                            <option value="null" hidden>{{$t('3174')}}</option>
                            <option value="" hidden>{{$t('3174')}}</option>
                            <option v-for="brakeCableDeliver in brakeCableDeliverSelection" v-bind:value="brakeCableDeliver">
                                {{brakeCableDeliver.text.useTextKey?$t(brakeCableDeliver.text.textKey):brakeCableDeliver.text.textUI}}
                            </option>
                        </select>
                    </div>
                    <div v-if="brakeCableDeliverSelection.length>0 && brakeCableDeliverSelection.length<=4">
                        <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: brakeCableDeliverSelection.length >0 && selectedBrakeCableDeliver==null, my_input_background_color_at_validInput: brakeCableDeliverSelection.length == 0 ||selectedBrakeCableDeliver!=null}">
                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                <li v-for="brakeCableDeliver in brakeCableDeliverSelection">
                                    <input type="checkbox" @input="change_Selected_atElementOf_brakeCableDeliver(brakeCableDeliver)" v-bind:checked="brakeCableDeliver.selected" v-bind:disabled="brakeCableDeliver.selected" />
                                    <span style="margin-left:10px">{{brakeCableDeliver.text.useTextKey?$t(brakeCableDeliver.text.textKey):brakeCableDeliver.text.textUI}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="brakeCablesShowDetails==true">
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3431')}}:</div>
                        </div>
                        <div v-if="brakeCableLengthSelection.length==0 || brakeCableLengthSelection.length>4">
                            <select v-model="selectedBrakeCableLength" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: brakeCableLengthSelection.length >0 && selectedBrakeCableLength==null, my_input_background_color_at_validInput: brakeCableLengthSelection.length == 0 ||selectedBrakeCableLength!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="brakeCableLength in brakeCableLengthSelection" v-bind:value="brakeCableLength">{{ValueDecimalSeparator(brakeCableLength.value)}}</option>
                            </select>
                        </div>
                        <div v-if="brakeCableLengthSelection.length>0 && brakeCableLengthSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: brakeCableLengthSelection.length >0 && selectedBrakeCableLength==null, my_input_background_color_at_validInput: brakeCableLengthSelection.length == 0 ||selectedBrakeCableLength!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="brakeCableLength in brakeCableLengthSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_brakeCableLength(brakeCableLength)" v-bind:checked="brakeCableLength.selected" v-bind:disabled="brakeCableLength.selected" />
                                        <span style="margin-left:10px">{{ValueDecimalSeparator(brakeCableLength.value)}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3426')}}:</div>
                        </div>
                        <div v-if="brakeCableTypeOfConnectionOnComponentSideSelection.length==0 || brakeCableTypeOfConnectionOnComponentSideSelection.length>4">
                            <select v-model="selectedBrakeCableTypeOfConnectionOnComponentSide" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: brakeCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedBrakeCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: brakeCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedBrakeCableTypeOfConnectionOnComponentSide!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="brakeCableTypeOfConnectionOnComponentSide in brakeCableTypeOfConnectionOnComponentSideSelection" v-bind:value="brakeCableTypeOfConnectionOnComponentSide">
                                    {{brakeCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(brakeCableTypeOfConnectionOnComponentSide.text.textKey):brakeCableTypeOfConnectionOnComponentSide.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="brakeCableTypeOfConnectionOnComponentSideSelection.length>0 && brakeCableTypeOfConnectionOnComponentSideSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: brakeCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedBrakeCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: brakeCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedBrakeCableTypeOfConnectionOnComponentSide!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="brakeCableTypeOfConnectionOnComponentSide in brakeCableTypeOfConnectionOnComponentSideSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_brakeCableTypeOfConnectionOnComponentSide(brakeCableTypeOfConnectionOnComponentSide)" v-bind:checked="brakeCableTypeOfConnectionOnComponentSide.selected" v-bind:disabled="brakeCableTypeOfConnectionOnComponentSide.selected" />
                                        <span style="margin-left:10px">{{brakeCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(brakeCableTypeOfConnectionOnComponentSide.text.textKey):brakeCableTypeOfConnectionOnComponentSide.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3422')}}:</div>
                        </div>
                        <div v-if="brakeCableSpecificationSelection.length==0 || brakeCableSpecificationSelection.length>4">
                            <select v-model="selectedBrakeCableSpecification" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: brakeCableSpecificationSelection.length >0 && selectedBrakeCableSpecification==null, my_input_background_color_at_validInput: brakeCableSpecificationSelection.length == 0 ||selectedBrakeCableSpecification!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="brakeCableSpecification in brakeCableSpecificationSelection" v-bind:value="brakeCableSpecification">
                                    {{brakeCableSpecification.text.useTextKey?$t(brakeCableSpecification.text.textKey):brakeCableSpecification.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="brakeCableSpecificationSelection.length>0 && brakeCableSpecificationSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: brakeCableSpecificationSelection.length >0 && selectedBrakeCableSpecification==null, my_input_background_color_at_validInput: brakeCableSpecificationSelection.length == 0 ||selectedBrakeCableSpecification!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="brakeCableSpecification in brakeCableSpecificationSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_brakeCableSpecification(brakeCableSpecification)" v-bind:checked="brakeCableSpecification.selected" v-bind:disabled="brakeCableSpecification.selected" />
                                        <span style="margin-left:10px">{{brakeCableSpecification.text.useTextKey?$t(brakeCableSpecification.text.textKey):brakeCableSpecification.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3466')}}:</div>
                        </div>
                        <div v-if="brakeCableNumberOfWiresAndCrossSectionSelection.length==0 || brakeCableNumberOfWiresAndCrossSectionSelection.length>4">
                            <select v-model="selectedBrakeCableNumberOfWiresAndCrossSection" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: brakeCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedBrakeCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: brakeCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedBrakeCableNumberOfWiresAndCrossSection!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="brakeCableNumberOfWiresAndCrossSection in brakeCableDeliverSelection" v-bind:value="brakeCableNumberOfWiresAndCrossSection">
                                    {{brakeCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(brakeCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                </option>
                            </select>
                        </div>
                        <div v-if="brakeCableNumberOfWiresAndCrossSectionSelection.length>0 && brakeCableNumberOfWiresAndCrossSectionSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: brakeCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedBrakeCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: brakeCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedBrakeCableNumberOfWiresAndCrossSection!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="brakeCableNumberOfWiresAndCrossSection in brakeCableNumberOfWiresAndCrossSectionSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_brakeCableNumberOfWiresAndCrossSection(brakeCableNumberOfWiresAndCrossSection)" v-bind:checked="brakeCableNumberOfWiresAndCrossSection.selected" v-bind:disabled="brakeCableNumberOfWiresAndCrossSection.selected" />
                                        {{brakeCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(brakeCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3427')}}:</div>
                        </div>
                        <div v-if="brakeCableBlockNumberSelection!=null&&brakeCableBlockNumberSelection.length>0">
                            <select v-model="selectedBrakeCableBlockNumber" class="my_select" style="width:100%">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="cable in brakeCableBlockNumberSelection" v-bind:value="cable">
                                    {{cable.blockNumber}} | {{cable.typeDesignation.useTextKey?$t(cable.typeDesignation.textKey):cable.typeDesignation.textUI}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
            <div style="overflow:auto">
                <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3440')}}</div>
                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                    <div>
                        <div class="ZAfont_family ZAfont_size">{{$t('3450')}}:</div>
                    </div>
                    <div v-if="brakeMonitoringCableDeliverSelection.length==0 || brakeMonitoringCableDeliverSelection.length>4">
                        <select v-model="selectedBrakeMonitoringCableDeliver" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput:brakeMonitoringCableDeliverSelection==null, my_input_background_color_at_validInput:brakeMonitoringCableDeliverSelection!=null}" v-bind:disabled="babl==true">
                            <option value="null" hidden>{{$t('3174')}}</option>
                            <option value="" hidden>{{$t('3174')}}</option>
                            <option v-for="brakeMonitoringCableDeliver in brakeMonitoringCableDeliverSelection" v-bind:value="brakeMonitoringCableDeliver">
                                {{brakeMonitoringCableDeliver.text.useTextKey?$t(brakeMonitoringCableDeliver.text.textKey):brakeMonitoringCableDeliver.text.textUI}}
                            </option>
                        </select>
                    </div>
                    <div v-if="brakeMonitoringCableDeliverSelection.length>0 && brakeMonitoringCableDeliverSelection.length<=4">
                        <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput:brakeMonitoringCableDeliverSelection==null, my_input_background_color_at_validInput:brakeMonitoringCableDeliverSelection!=null}">
                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                <li v-for="brakeMonitoringCableDeliver in brakeMonitoringCableDeliverSelection">
                                    <input type="checkbox" @input="change_Selected_atElementOf_brakeMonitoringCableDeliver(brakeMonitoringCableDeliver)" v-bind:checked="brakeMonitoringCableDeliver.selected" v-bind:disabled="brakeMonitoringCableDeliver.selected || babl==true" />
                                    <span style="margin-left:10px">{{brakeMonitoringCableDeliver.text.useTextKey?$t(brakeMonitoringCableDeliver.text.textKey):brakeMonitoringCableDeliver.text.textUI}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="brakeMonitoringCablesShowDetails==true">
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3431')}}:</div>
                        </div>
                        <div v-if="brakeMonitoringCableLengthSelection.length==0 || brakeMonitoringCableLengthSelection.length>4">
                            <select v-model="selectedBrakeMonitoringCableLength" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: brakeMonitoringCableLengthSelection.length >0 && selectedBrakeMonitoringCableLength==null, my_input_background_color_at_validInput: brakeMonitoringCableLengthSelection.length == 0 ||selectedBrakeMonitoringCableLength!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="brakeMonitoringCableLength in brakeMonitoringCableLengthSelection" v-bind:value="brakeMonitoringCableLength">{{ValueDecimalSeparator(brakeMonitoringCableLength.value)}}</option>
                            </select>
                        </div>
                        <div v-if="brakeMonitoringCableLengthSelection.length>0 && brakeMonitoringCableLengthSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: brakeMonitoringCableLengthSelection.length >0 && selectedBrakeMonitoringCableLength==null, my_input_background_color_at_validInput: brakeMonitoringCableLengthSelection.length == 0 ||selectedBrakeMonitoringCableLength!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="brakeMonitoringCableLength in brakeMonitoringCableLengthSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_brakeMonitoringCableLength(brakeMonitoringCableLength)" v-bind:checked="brakeMonitoringCableLength.selected" v-bind:disabled="brakeMonitoringCableLength.selected" />
                                        <span style="margin-left:10px">{{ValueDecimalSeparator(brakeMonitoringCableLength.value)}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3426')}}:</div>
                        </div>
                        <div v-if="brakeMonitoringCableTypeOfConnectionOnComponentSideSelection.length==0 || brakeMonitoringCableTypeOfConnectionOnComponentSideSelection.length>4">
                            <select v-model="selectedBrakeMonitoringCableTypeOfConnectionOnComponentSide" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: brakeMonitoringCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedBrakeMonitoringCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: brakeMonitoringCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedBrakeMonitoringCableTypeOfConnectionOnComponentSide!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="brakeMonitoringCableTypeOfConnectionOnComponentSide in brakeMonitoringCableTypeOfConnectionOnComponentSideSelection" v-bind:value="brakeMonitoringCableTypeOfConnectionOnComponentSide">
                                    {{brakeMonitoringCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(brakeMonitoringCableTypeOfConnectionOnComponentSide.text.textKey):brakeMonitoringCableTypeOfConnectionOnComponentSide.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="brakeMonitoringCableTypeOfConnectionOnComponentSideSelection.length>0 && brakeMonitoringCableTypeOfConnectionOnComponentSideSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: brakeMonitoringCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedBrakeMonitoringCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: brakeMonitoringCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedBrakeMonitoringCableTypeOfConnectionOnComponentSide!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="brakeMonitoringCableTypeOfConnectionOnComponentSide in brakeMonitoringCableTypeOfConnectionOnComponentSideSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_brakeMonitoringCableTypeOfConnectionOnComponentSide(brakeMonitoringCableTypeOfConnectionOnComponentSide)" v-bind:checked="brakeMonitoringCableTypeOfConnectionOnComponentSide.selected" v-bind:disabled="brakeMonitoringCableTypeOfConnectionOnComponentSide.selected" />
                                        <span style="margin-left:10px">{{brakeMonitoringCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(brakeMonitoringCableTypeOfConnectionOnComponentSide.text.textKey):brakeMonitoringCableTypeOfConnectionOnComponentSide.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3422')}}:</div>
                        </div>
                        <div v-if="brakeMonitoringCableSpecificationSelection.length==0 || brakeMonitoringCableSpecificationSelection.length>4">
                            <select v-model="selectedBrakeMonitoringCableSpecification" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: brakeMonitoringCableSpecificationSelection.length >0 && selectedBrakeMonitoringCableSpecification==null, my_input_background_color_at_validInput: brakeMonitoringCableSpecificationSelection.length == 0 ||selectedBrakeMonitoringCableSpecification!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="brakeMonitoringCableSpecification in brakeMonitoringCableDeliverSelection" v-bind:value="brakeMonitoringCableSpecification">
                                    {{brakeMonitoringCableSpecification.text.useTextKey?$t(brakeMonitoringCableSpecification.text.textKey):brakeMonitoringCableSpecification.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="brakeMonitoringCableSpecificationSelection.length>0 && brakeMonitoringCableSpecificationSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: brakeMonitoringCableSpecificationSelection.length >0 && selectedBrakeMonitoringCableSpecification==null, my_input_background_color_at_validInput: brakeMonitoringCableSpecificationSelection.length == 0 ||selectedBrakeMonitoringCableSpecification!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="brakeMonitoringCableSpecification in brakeMonitoringCableSpecificationSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_brakeMonitoringCableSpecification(brakeMonitoringCableSpecification)" v-bind:checked="brakeMonitoringCableSpecification.selected" v-bind:disabled="brakeMonitoringCableSpecification.selected" />
                                        <span style="margin-left:10px">{{brakeMonitoringCableSpecification.text.useTextKey?$t(brakeMonitoringCableSpecification.text.textKey):brakeMonitoringCableSpecification.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3466')}}:</div>
                        </div>
                        <div v-if="brakeMonitoringCableNumberOfWiresAndCrossSectionSelection.length==0 || brakeMonitoringCableNumberOfWiresAndCrossSectionSelection.length>4">
                            <select v-model="selectedBrakeMonitoringCableNumberOfWiresAndCrossSection" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: brakeMonitoringCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedBrakeMonitoringCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: brakeMonitoringCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedBrakeMonitoringCableNumberOfWiresAndCrossSection!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="brakeMonitoringCableNumberOfWiresAndCrossSection in brakeMonitoringCableDeliverSelection" v-bind:value="brakeMonitoringCableNumberOfWiresAndCrossSection">
                                    {{brakeMonitoringCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(brakeMonitoringCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                </option>
                            </select>
                        </div>
                        <div v-if="brakeMonitoringCableNumberOfWiresAndCrossSectionSelection.length>0 && brakeMonitoringCableNumberOfWiresAndCrossSectionSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: brakeMonitoringCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedBrakeMonitoringCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: brakeMonitoringCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedBrakeMonitoringCableNumberOfWiresAndCrossSection!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="brakeMonitoringCableNumberOfWiresAndCrossSection in brakeMonitoringCableNumberOfWiresAndCrossSectionSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_brakeMonitoringCableNumberOfWiresAndCrossSection(brakeMonitoringCableNumberOfWiresAndCrossSection)" v-bind:checked="brakeMonitoringCableNumberOfWiresAndCrossSection.selected" v-bind:disabled="brakeMonitoringCableNumberOfWiresAndCrossSection.selected" />
                                        {{brakeMonitoringCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(brakeMonitoringCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3427')}}:</div>
                        </div>
                        <div v-if="brakeMonitoringCableBlockNumberSelection!=null&&brakeMonitoringCableBlockNumberSelection.length>0">
                            <select v-model="selectedBrakeMonitoringCableBlockNumber" class="my_select" style="width:100%">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="cable in brakeMonitoringCableBlockNumberSelection" v-bind:value="cable">
                                    {{cable.blockNumber}} | {{cable.typeDesignation.useTextKey?$t(cable.typeDesignation.textKey):cable.typeDesignation.textUI}}
                                </option>
                            </select>
                        </div>

                    </div>
                </div>
                <hr />
            </div>
            <div style="overflow:auto">
                <div class="my_color_00338e my_fontWeight_600 my_fontSize_1Point5 ZAfont_family">{{$t('3547')}}</div>
                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                    <div>
                        <div class="ZAfont_family ZAfont_size">{{$t('3450')}}:</div>
                    </div>
                    <div v-if="forcedVentilationCableDeliverSelection.length==0 || forcedVentilationCableDeliverSelection.length>4">
                        <select v-model="selectedForcedVentilationCableDeliver" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput:selectedForcedVentilationCableDeliver==null, my_input_background_color_at_validInput:selectedForcedVentilationCableDeliver!=null}">
                            <option value="null" hidden>{{$t('3174')}}</option>
                            <option value="" hidden>{{$t('3174')}}</option>
                            <option v-for="forcedVentilationCableDeliver in forcedVentilationCableDeliverSelection" v-bind:value="forcedVentilationCableDeliver" v-bind:disabled="forcedVentilationCableDeliverSelection.length==0">
                                {{forcedVentilationCableDeliver.text.useTextKey?$t(forcedVentilationCableDeliver.text.textKey):forcedVentilationCableDeliver.text.textUI}}
                            </option>
                        </select>
                    </div>
                    <div v-if="forcedVentilationCableDeliverSelection.length>0 && forcedVentilationCableDeliverSelection.length<=4">
                        <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput:selectedForcedVentilationCableDeliver==null, my_input_background_color_at_validInput:selectedForcedVentilationCableDeliver!=null}">
                            <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                <li v-for="forcedVentilationCableDeliver in forcedVentilationCableDeliverSelection">
                                    <input type="checkbox" @input="change_Selected_atElementOf_forcedVentilationCableDeliver(forcedVentilationCableDeliver)" v-bind:checked="forcedVentilationCableDeliver.selected" v-bind:disabled="forcedVentilationCableDeliver.selected" />
                                    <span style="margin-left:10px">{{forcedVentilationCableDeliver.text.useTextKey?$t(forcedVentilationCableDeliver.text.textKey):forcedVentilationCableDeliver.text.textUI}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="forcedVentilationCablesShowDetails==true">
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3431')}}:</div>
                        </div>
                        <div v-if="forcedVentilationCableLengthSelection.length==0 || forcedVentilationCableLengthSelection.length>4">
                            <select v-model="selectedForcedVentilationCableLength" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: forcedVentilationCableLengthSelection.length >0 && selectedForcedVentilationCableLength==null, my_input_background_color_at_validInput: forcedVentilationCableLengthSelection.length == 0 ||selectedForcedVentilationCableLength!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="forcedVentilationCableLength in forcedVentilationCableLengthSelection" v-bind:value="forcedVentilationCableLength">{{ValueDecimalSeparator(forcedVentilationCableLength.value)}}</option>
                            </select>
                        </div>
                        <div v-if="forcedVentilationCableLengthSelection.length>0 && forcedVentilationCableLengthSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: forcedVentilationCableLengthSelection.length >0 && selectedForcedVentilationCableLength==null, my_input_background_color_at_validInput: forcedVentilationCableLengthSelection.length == 0 ||selectedForcedVentilationCableLength!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="forcedVentilationCableLength in forcedVentilationCableLengthSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_forcedVentilationCableLength(forcedVentilationCableLength)" v-bind:checked="forcedVentilationCableLength.selected" v-bind:disabled="forcedVentilationCableLength.selected" />
                                        <span style="margin-left:10px">{{ValueDecimalSeparator(forcedVentilationCableLength.value)}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3426')}}:</div>
                        </div>
                        <div v-if="forcedVentilationCableTypeOfConnectionOnComponentSideSelection.length==0 || forcedVentilationCableTypeOfConnectionOnComponentSideSelection.length>4">
                            <select v-model="selectedForcedVentilationCableTypeOfConnectionOnComponentSide" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: forcedVentilationCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedForcedVentilationCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: forcedVentilationCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedForcedVentilationCableTypeOfConnectionOnComponentSide!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="forcedVentilationCableTypeOfConnectionOnComponentSide in forcedVentilationCableTypeOfConnectionOnComponentSideSelection" v-bind:value="forcedVentilationCableTypeOfConnectionOnComponentSide">
                                    {{forcedVentilationCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(forcedVentilationCableTypeOfConnectionOnComponentSide.text.textKey):forcedVentilationCableTypeOfConnectionOnComponentSide.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="forcedVentilationCableTypeOfConnectionOnComponentSideSelection.length>0 && forcedVentilationCableTypeOfConnectionOnComponentSideSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: forcedVentilationCableTypeOfConnectionOnComponentSideSelection.length >0 && selectedForcedVentilationCableTypeOfConnectionOnComponentSide==null, my_input_background_color_at_validInput: forcedVentilationCableTypeOfConnectionOnComponentSideSelection.length == 0 ||selectedForcedVentilationCableTypeOfConnectionOnComponentSide!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="forcedVentilationCableTypeOfConnectionOnComponentSide in forcedVentilationCableTypeOfConnectionOnComponentSideSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_forcedVentilationCableTypeOfConnectionOnComponentSide(forcedVentilationCableTypeOfConnectionOnComponentSide)" v-bind:checked="forcedVentilationCableTypeOfConnectionOnComponentSide.selected" v-bind:disabled="forcedVentilationCableTypeOfConnectionOnComponentSide.selected" />
                                        <span style="margin-left:10px">{{forcedVentilationCableTypeOfConnectionOnComponentSide.text.useTextKey?$t(forcedVentilationCableTypeOfConnectionOnComponentSide.text.textKey):forcedVentilationCableTypeOfConnectionOnComponentSide.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3422')}}:</div>
                        </div>
                        <div v-if="forcedVentilationCableSpecificationSelection.length==0 || forcedVentilationCableSpecificationSelection.length>4">
                            <select v-model="selectedForcedVentilationCableSpecification" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: forcedVentilationCableSpecificationSelection.length >0 && selectedForcedVentilationCableSpecification==null, my_input_background_color_at_validInput: forcedVentilationCableSpecificationSelection.length == 0 ||selectedForcedVentilationCableSpecification!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="forcedVentilationCableSpecification in forcedVentilationCableSpecificationSelection" v-bind:value="forcedVentilationCableSpecification">
                                    {{forcedVentilationCableSpecification.text.useTextKey?$t(forcedVentilationCableSpecification.text.textKey):forcedVentilationCableSpecification.text.textUI}}
                                </option>
                            </select>
                        </div>
                        <div v-if="forcedVentilationCableSpecificationSelection.length>0 && forcedVentilationCableSpecificationSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: forcedVentilationCableSpecificationSelection.length >0 && selectedForcedVentilationCableSpecification==null, my_input_background_color_at_validInput: forcedVentilationCableSpecificationSelection.length == 0 ||selectedForcedVentilationCableSpecification!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="forcedVentilationCableSpecification in forcedVentilationCableSpecificationSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_forcedVentilationCableSpecification(forcedVentilationCableSpecification)" v-bind:checked="forcedVentilationCableSpecification.selected" v-bind:disabled="forcedVentilationCableSpecification.selected" />
                                        <span style="margin-left:10px">{{forcedVentilationCableSpecification.text.useTextKey?$t(forcedVentilationCableSpecification.text.textKey):forcedVentilationCableSpecification.text.textUI}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3466')}}:</div>
                        </div>
                        <div v-if="forcedVentilationCableNumberOfWiresAndCrossSectionSelection.length==0 || forcedVentilationCableNumberOfWiresAndCrossSectionSelection.length>4">
                            <select v-model="selectedForcedVentilationCableNumberOfWiresAndCrossSection" class="my_select" style="width:100%" v-bind:class="{my_input_border_at_invalidInput: forcedVentilationCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedForcedVentilationCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: forcedVentilationCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedForcedVentilationCableNumberOfWiresAndCrossSection!=null}">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="forcedVentilationCableNumberOfWiresAndCrossSection in forcedVentilationCableDeliverSelection" v-bind:value="forcedVentilationCableNumberOfWiresAndCrossSection">
                                    {{forcedVentilationCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(forcedVentilationCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                </option>
                            </select>
                        </div>
                        <div v-if="forcedVentilationCableNumberOfWiresAndCrossSectionSelection.length>0 && motorCableNumberOfWiresAndCrossSectionSelection.length<=4">
                            <div style="display: grid;" v-bind:class="{my_input_border_at_invalidInput: forcedVentilationCableNumberOfWiresAndCrossSectionSelection.length >0 && selectedForcedVentilationCableNumberOfWiresAndCrossSection==null, my_input_background_color_at_validInput: forcedVentilationCableNumberOfWiresAndCrossSectionSelection.length == 0 ||selectedForcedVentilationCableNumberOfWiresAndCrossSection!=null}">
                                <ul class="my_inputCheckbox ZAfont_family ZAfont_size">
                                    <li v-for="forcedVentilationCableNumberOfWiresAndCrossSection in forcedVentilationCableNumberOfWiresAndCrossSectionSelection">
                                        <input type="checkbox" @input="change_Selected_atElementOf_forcedVentilationCableNumberOfWiresAndCrossSection(forcedVentilationCableNumberOfWiresAndCrossSection)" v-bind:checked="forcedVentilationCableNumberOfWiresAndCrossSection.selected" v-bind:disabled="forcedVentilationCableNumberOfWiresAndCrossSection.selected" />
                                        {{forcedVentilationCableNumberOfWiresAndCrossSection.numberOfWires}} x {{ValueDecimalSeparator(forcedVentilationCableNumberOfWiresAndCrossSection.crossSection)}} mm²
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="ZAfont_family ZAfont_size" style="display: grid; grid-template-columns: 1fr 1fr 1fr; grid-column-gap: 10px; margin-top: 20px">
                        <div>
                            <div class="ZAfont_family ZAfont_size">{{$t('3427')}}:</div>
                        </div>
                        <div v-if="forcedVentilationCableBlockNumberSelection!=null&&forcedVentilationCableBlockNumberSelection.length>0">
                            <select v-model="selectedForcedVentilationCableBlockNumber" class="my_select" style="width:100%">
                                <option value="null" hidden>{{$t('3174')}}</option>
                                <option value="" hidden>{{$t('3174')}}</option>
                                <option v-for="cable in forcedVentilationCableBlockNumberSelection" v-bind:value="cable">
                                    {{cable.blockNumber}} | {{cable.typeDesignation.useTextKey?$t(cable.typeDesignation.textKey):cable.typeDesignation.textUI}}
                                </option>
                            </select>
                        </div>

                    </div>
                </div>
                <hr />
            </div>
            <div class="my_btn_nextConfigurationStep_position">
                <button @click="furtherToManualHome()" class="btn my_btn_nextConfigurationStep" style="margin-right: 5px">{{$t('3366')}}</button>
                <button @click="furtherTo()" class="btn my_btn_nextConfigurationStep">{{$t('1023')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import router from '../../../router';
    import Images from '../../configuration/Images';
    export default {
        name: 'Cables',
        components: {
            Images,
        },
        data() {
            return {
                cablesModalShown: false,
                cableHeadline: '',
                imagePath_Cable: '',
                imagePath_Cable2: '',
                imagePath_EncoderConnectionCable: '/Leitung/L-GA.jpg',
            }
        },
        created() {
            this.$store.commit('configurations/MANU_configuration', true);
            this.$store.dispatch('cables/get_cableInformationsManual_storeAction');
        },
        computed: {
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            plusManual: {
                get() {
                    return this.$store.state.configurations.plusManual;
                }
            },
            encoderType: {
                get() {
                    var hasElevatorMotor_Encoder_Selection = this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Data != null
                        && this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Data.hasOwnProperty("elevatorMotor_Encoder_Selection")
                        && this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection.length > 0

                    var hasMotorManualData = this.$store.state.inputsManual.motorManualData != null
                        && this.$store.state.inputsManual.motorManualData.hasOwnProperty('details')
                        && this.$store.state.inputsManual.motorManualData.details.gtyp != null

                    if (hasElevatorMotor_Encoder_Selection) {

                        const selectedItem = this.$store.state.driveTechnologiesManual.elevatorMotor_Encoder_Data.elevatorMotor_Encoder_Selection.find(i => i.selected == true);
                        return selectedItem != null ? selectedItem.elevatorMotor_Encoder.typeDesignation : null;
                    }
                    else if (hasMotorManualData) {
                        return this.$store.state.inputsManual.motorManualData.details.gtyp;
                    }
                    else {
                        return null;
                    }
                }
            },
            // encoder connection
            encoderConnectionInformation: {
                get() {
                    return this.$store.state.cables.encoderConnectionInformation != null
                        && this.$store.state.cables.encoderConnectionInformation.hasOwnProperty('necessary')
                        && this.$store.state.cables.encoderConnectionInformation.hasOwnProperty('details')
                        && this.$store.state.cables.encoderConnectionInformation.necessary == true
                        ? this.$store.state.cables.encoderConnectionInformation.details
                        : null;
                },
            },

            selectedEncoderConnection: {
                get() {

                    const valuelist = this.$store.state.cables.encoderConnectionInformation != null
                        && this.$store.state.cables.encoderConnectionInformation.hasOwnProperty('details')
                        ? this.$store.state.cables.encoderConnectionInformation.details
                        : null;

                    if (!Array.isArray(valuelist)) {
                        return null;
                    }

                    return valuelist.find(i => i.selected == true);
                },
                set(value) {
                    this.change_Selected_atElementOf_encoderConnectionCableBlockNumber(value);
                }
            },
            // encoder data
            encoderCableDeliverSelection: {
                get() {
                    return this.$store.state.cables.encoderCableDeliverSelection;
                },
            },
            selectedEncoderCableDeliver: {
                get() {
                    return this.$store.getters['cables/selectedEncoderCableDeliver'];
                },

                set(value) {
                    this.change_Selected_atElementOf_encoderCableDeliver(value);
                }
            },
            encoderCablesShowDetails: {
                get() {
                    const valuelist = this.encoderCableDeliverSelection;

                    if (!Array.isArray(valuelist)) {
                        return false;
                    }

                    const selectedItem = valuelist.find(i => i.selected == true);
                    return selectedItem != null ? selectedItem.showDetails : false;
                },
            },
            encoderCableLengthSelection: {
                get() {
                    return this.$store.state.cables.encoderCableLengthSelection;
                },
            },
            selectedEncoderCableLength: {
                get() {
                    return this.$store.getters['cables/selectedEncoderCableLength'];
                },
                set(value) {
                    this.change_Selected_atElementOf_encoderCableLength(value);
                }
            },
            encoderCableTypeOfConnectionOnComponentSideSelection: {
                get() {
                    return this.$store.state.cables.encoderCableTypeOfConnectionOnComponentSideSelection;
                },
            },
            selectedEncoderCableTypeOfConnectionOnComponentSide: {
                get() {
                    return this.$store.getters['cables/selectedEncoderCableTypeOfConnectionOnComponentSide'];
                },
                set(value) {
                    this.change_Selected_atElementOf_encoderCableTypeOfConnectionOnComponentSide(value);
                }
            },
            encoderCableSpecificationSelection: {
                get() {
                    return this.$store.state.cables.encoderCableSpecificationSelection;
                },
            },
            selectedEncoderCableSpecification: {
                get() {
                    return this.$store.getters['cables/selectedEncoderCableSpecification'];
                },
                set(value) {
                    this.change_Selected_atElementOf_encoderCableSpecification(value);
                }
            },
            encoderCableNumberOfWiresAndCrossSectionSelection: {
                get() {
                    return this.$store.state.cables.encoderCableNumberOfWiresAndCrossSectionSelection;
                },
            },
            selectedEncoderCableNumberOfWiresAndCrossSection: {
                get() {
                    return this.$store.getters['cables/encoderCableNumberOfWiresAndCrossSection'];
                },
                set(value) {
                    this.change_Selected_atElementOf_encoderCableNumberOfWiresAndCrossSection(value);
                }
            },
            encoderCableBlockNumberSelection: {
                get() {
                    return this.$store.state.cables.encoderCableBlockNumberSelection != null
                        && Array.isArray(this.$store.state.cables.encoderCableBlockNumberSelection)
                        ? this.$store.state.cables.encoderCableBlockNumberSelection
                        : null;
                },
            },
            selectedEncoderCableBlockNumber: {
                get() {
                    return this.$store.getters['cables/selectedEncoderCableBlockNumber'];
                },
                set(value) {
                    this.change_Selected_atElementOf_encoderCableBlockNumberSelection(value);
                }
            },
            encoderCableTypeDesignation: {
                get() {
                    return this.selectedEncoderCableBlockNumber != null
                        && this.selectedEncoderCableBlockNumber.hasOwnProperty('typeDesignation')
                        ? this.selectedEncoderCableBlockNumber.typeDesignation
                        : null;
                },
            },

            // motor data
            motorCableDeliverSelection: {
                get() {
                    return this.$store.state.cables.cables_Data != null
                        && this.$store.state.cables.cables_Data.hasOwnProperty('motorCable_DeliverOption_Valuelist')
                        ? this.$store.state.cables.cables_Data.motorCable_DeliverOption_Valuelist
                        : [];
                },
            },
            selectedMotorCableDeliver: {
                get() {
                    return this.$store.getters['cables/selectedMotorCableDeliver'];
                },
                set(value) {
                    this.change_Selected_atElementOf_motorCableDeliver(value);
                }
            },
            motorCablesShowDetails: {
                get() {
                    const valuelist = this.$store.state.cables.cables_Data != null
                        ? this.$store.state.cables.cables_Data.motorCable_DeliverOption_Valuelist
                        : null;

                    if (!Array.isArray(valuelist)) {
                        return false;
                    }

                    const selectedItem = valuelist.find(i => i.selected == true);
                    return selectedItem != null ? selectedItem.showDetails : false;
                },
            },
            motorCableLengthSelection: {
                get() {
                    return this.$store.state.cables.motorCableLengthSelection;
                },
            },
            selectedMotorCableLength: {
                get() {
                    return this.$store.getters['cables/selectedMotorCableLength'];
                },
                set(value) {
                    this.change_Selected_atElementOf_motorCableLength(value);
                }
            },
            motorCableTypeOfConnectionOnComponentSideSelection: {
                get() {
                    return this.$store.state.cables.motorCableTypeOfConnectionOnComponentSideSelection;
                },
            },
            selectedMotorCableTypeOfConnectionOnComponentSide: {
                get() {
                    return this.$store.getters['cables/selectedMotorCableTypeOfConnectionOnComponentSide'];
                },
                set(value) {
                    this.change_Selected_atElementOf_motorCableTypeOfConnectionOnComponentSide(value);
                }
            },
            motorCableSpecificationSelection: {
                get() {
                    return this.$store.state.cables.motorCableSpecificationSelection;
                },
            },
            selectedMotorCableSpecification: {
                get() {
                    return this.$store.getters['cables/selectedMotorCableSpecification'];
                },
                set(value) {
                    this.change_Selected_atElementOf_motorCableSpecification(value);
                }
            },
            motorCableNumberOfWiresAndCrossSectionSelection: {
                get() {
                    return this.$store.state.cables.motorCableNumberOfWiresAndCrossSectionSelection;
                },
            },
            selectedMotorCableNumberOfWiresAndCrossSection: {
                get() {
                    return this.$store.getters['cables/motorCableNumberOfWiresAndCrossSection'];
                },
                set(value) {
                    this.change_Selected_atElementOf_motorCableNumberOfWiresAndCrossSection(value);
                }
            },
            motorCableBlockNumberSelection: {
                get() {
                    return this.$store.state.cables.motorCableBlockNumberSelection != null
                        && Array.isArray(this.$store.state.cables.motorCableBlockNumberSelection)
                        ? this.$store.state.cables.motorCableBlockNumberSelection
                        : null;
                },
            },
                selectedMotorCableBlockNumber: {
                    get() {
                        return this.$store.getters['cables/selectedMotorCableBlockNumber'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_motorCableBlockNumberSelection(value);
                    }
                },
                motorCableTypeDesignation: {
                    get() {
                        return this.selectedMotorCableBlockNumber != null
                            && this.selectedMotorCableBlockNumber.hasOwnProperty('typeDesignation')
                            ? this.selectedMotorCableBlockNumber.typeDesignation
                            : null;
                    },
                },

                // motor protection data
                motorProtectionCableDeliverSelection: {
                    get() {
                        return this.$store.state.cables.cables_Data != null
                            && this.$store.state.cables.cables_Data.hasOwnProperty('motorProtectionCable_DeliverOption_Valuelist')
                            ? this.$store.state.cables.cables_Data.motorProtectionCable_DeliverOption_Valuelist
                            : [];
                    },
                },
                selectedMotorProtectionCableDeliver: {
                    get() {
                        return this.$store.getters['cables/selectedMotorProtectionCableDeliver'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_motorProtectionCableDeliver(value);
                    }
                },
                motorProtectionCablesShowDetails: {
                    get() {
                        const valuelist = this.$store.state.cables.cables_Data != null
                            ? this.$store.state.cables.cables_Data.motorProtectionCable_DeliverOption_Valuelist
                            : null;

                        if (!Array.isArray(valuelist)) {
                            return false;
                        }

                        const selectedItem = valuelist.find(i => i.selected == true);
                        return selectedItem != null ? selectedItem.showDetails : false;
                    },
                },
                motorProtectionCableLengthSelection: {
                    get() {
                        return this.$store.state.cables.motorProtectionCableLengthSelection;
                    },
                },
                selectedMotorProtectionCableLength: {
                    get() {
                        return this.$store.getters['cables/selectedMotorProtectionCableLength'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_motorProtectionCableLength(value);
                    }
                },
                motorProtectionCableTypeOfConnectionOnComponentSideSelection: {
                    get() {
                        return this.$store.state.cables.motorProtectionCableTypeOfConnectionOnComponentSideSelection;
                    },
                },
                selectedMotorProtectionCableTypeOfConnectionOnComponentSide: {
                    get() {
                        return this.$store.getters['cables/selectedMotorProtectionCableTypeOfConnectionOnComponentSide'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_motorProtectionCableTypeOfConnectionOnComponentSide(value);
                    }
                },
                motorProtectionCableSpecificationSelection: {
                    get() {
                        return this.$store.state.cables.motorProtectionCableSpecificationSelection;
                    },
                },
                selectedMotorProtectionCableSpecification: {
                    get() {
                        return this.$store.getters['cables/selectedMotorProtectionCableSpecification'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_motorProtectionCableSpecification(value);
                    }
                },
                motorProtectionCableNumberOfWiresAndCrossSectionSelection: {
                    get() {
                        return this.$store.state.cables.motorProtectionCableNumberOfWiresAndCrossSectionSelection;
                    },
                },
                selectedMotorProtectionCableNumberOfWiresAndCrossSection: {
                    get() {
                        return this.$store.getters['cables/motorProtectionCableNumberOfWiresAndCrossSection'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_motorProtectionCableNumberOfWiresAndCrossSection(value);
                    }
                },
                motorProtectionCableBlockNumberSelection: {
                    get() {
                        return this.$store.state.cables.motorProtectionCableBlockNumberSelection != null
                            && Array.isArray(this.$store.state.cables.motorProtectionCableBlockNumberSelection)
                            ? this.$store.state.cables.motorProtectionCableBlockNumberSelection
                            : null;
                    },
                },
                selectedMotorProtectionCableBlockNumber: {
                    get() {
                        return this.$store.getters['cables/selectedMotorProtectionCableBlockNumber'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_motorProtectionCableBlockNumberSelection(value);
                    }
                },
                motorProtectionCableTypeDesignation: {
                    get() {
                        return this.selectedMotorProtectionCableBlockNumber != null
                            && this.selectedMotorProtectionCableBlockNumber.hasOwnProperty('typeDesignation')
                            ? this.selectedMotorProtectionCableBlockNumber.typeDesignation
                            : null;
                    },
                },

                // brake data
                brakeCableDeliverSelection: {
                    get() {
                        return this.$store.state.cables.cables_Data != null
                            && this.$store.state.cables.cables_Data.hasOwnProperty('brakeCable_DeliverOption_Valuelist')
                            ? this.$store.state.cables.cables_Data.brakeCable_DeliverOption_Valuelist
                            : [];
                    },
                },
                selectedBrakeCableDeliver: {
                    get() {
                        return this.$store.getters['cables/selectedBrakeCableDeliver'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_brakeCableDeliver(value);
                    }
                },
                brakeCablesShowDetails: {
                    get() {
                        const valuelist = this.$store.state.cables.cables_Data != null
                            ? this.$store.state.cables.cables_Data.brakeCable_DeliverOption_Valuelist
                            : null;

                        if (!Array.isArray(valuelist)) {
                            return false;
                        }

                        const selectedItem = valuelist.find(i => i.selected == true);
                        return selectedItem != null ? selectedItem.showDetails : false;
                    },
                },
                brakeCableLengthSelection: {
                    get() {
                        return this.$store.state.cables.brakeCableLengthSelection;
                    },
                },
                selectedBrakeCableLength: {
                    get() {
                        return this.$store.getters['cables/selectedBrakeCableLength'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_brakeCableLength(value);
                    }
                },
                brakeCableTypeOfConnectionOnComponentSideSelection: {
                    get() {
                        return this.$store.state.cables.brakeCableTypeOfConnectionOnComponentSideSelection;
                    },
                },
                selectedBrakeCableTypeOfConnectionOnComponentSide: {
                    get() {
                        return this.$store.getters['cables/selectedBrakeCableTypeOfConnectionOnComponentSide'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_brakeCableTypeOfConnectionOnComponentSide(value);
                    }
                },
                brakeCableSpecificationSelection: {
                    get() {
                        return this.$store.state.cables.brakeCableSpecificationSelection;
                    },
                },
                selectedBrakeCableSpecification: {
                    get() {
                        return this.$store.getters['cables/selectedBrakeCableSpecification'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_brakeCableSpecification(value);
                    }
                },
                brakeCableNumberOfWiresAndCrossSectionSelection: {
                    get() {
                        return this.$store.state.cables.brakeCableNumberOfWiresAndCrossSectionSelection;
                    },
                },
                selectedBrakeCableNumberOfWiresAndCrossSection: {
                    get() {
                        return this.$store.getters['cables/brakeCableNumberOfWiresAndCrossSection'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_brakeCableNumberOfWiresAndCrossSection(value);
                    }
                },
                brakeCableBlockNumberSelection: {
                    get() {
                        return this.$store.state.cables.brakeCableBlockNumberSelection != null
                            && Array.isArray(this.$store.state.cables.brakeCableBlockNumberSelection)
                            ? this.$store.state.cables.brakeCableBlockNumberSelection
                            : null;
                    },
                },
                selectedBrakeCableBlockNumber: {
                    get() {
                        return this.$store.getters['cables/selectedBrakeCableBlockNumber'];
                    },
                    set(value) {
                        this.change_Selected_atElementOf_brakeCableBlockNumberSelection(value);
                    }
                },
                brakeCableTypeDesignation: {
                    get() {
                        return this.selectedBrakeCableBlockNumber != null
                            && this.selectedBrakeCableBlockNumber.hasOwnProperty('typeDesignation')
                            ? this.selectedBrakeCableBlockNumber.typeDesignation
                            : null;
                    },
                },
                babl: {
                    get() {
                        return this.$store.state.cables.babl;
                    },
                },

                // brake monitoring data
                brakeMonitoringCableDeliverSelection: {
                    get() {
                        return this.$store.state.cables.cables_Data != null
                            && this.$store.state.cables.cables_Data.hasOwnProperty('brakeMonitoringCable_DeliverOption_Valuelist')
                            ? this.$store.state.cables.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist : [];
                    },
                },
                    selectedBrakeMonitoringCableDeliver: {
                        get() {
                            return this.$store.getters['cables/selectedBrakeMonitoringCableDeliver'];
                        },
                        set(value) {
                            this.change_Selected_atElementOf_brakeMonitoringCableDeliver(value);
                        }

                    },
                    brakeMonitoringCablesShowDetails: {
                        get() {
                            const valuelist = this.$store.state.cables.cables_Data != null
                                ? this.$store.state.cables.cables_Data.brakeMonitoringCable_DeliverOption_Valuelist
                                : null;

                            if (!Array.isArray(valuelist)) {
                                return false;
                            }

                            const selectedItem = valuelist.find(i => i.selected == true);
                            return selectedItem != null ? selectedItem.showDetails : false;
                        },
                    },
                    brakeMonitoringCableLengthSelection: {
                        get() {
                            return this.$store.state.cables.brakeMonitoringCableLengthSelection;
                        },
                    },
                    selectedBrakeMonitoringCableLength: {
                        get() {
                            return this.$store.getters['cables/selectedBrakeMonitoringCableLength'];
                        },
                        set(value) {
                            this.change_Selected_atElementOf_brakeMonitoringCableLength(value);
                        }
                    },
                    brakeMonitoringCableTypeOfConnectionOnComponentSideSelection: {
                        get() {
                            return this.$store.state.cables.brakeMonitoringCableTypeOfConnectionOnComponentSideSelection;
                        },
                    },
                    selectedBrakeMonitoringCableTypeOfConnectionOnComponentSide: {
                        get() {
                            return this.$store.getters['cables/selectedBrakeMonitoringCableTypeOfConnectionOnComponentSide'];
                        },
                        set(value) {
                            this.change_Selected_atElementOf_brakeMonitoringCableTypeOfConnectionOnComponentSide(value);
                        }
                    },
                    brakeMonitoringCableSpecificationSelection: {
                        get() {
                            return this.$store.state.cables.brakeMonitoringCableSpecificationSelection;
                        },
                    },
                    selectedBrakeMonitoringCableSpecification: {
                        get() {
                            return this.$store.getters['cables/selectedBrakeMonitoringCableSpecification'];
                        },
                        set(value) {
                            this.change_Selected_atElementOf_brakeMonitoringCableSpecification(value);
                        }
                    },
                    brakeMonitoringCableNumberOfWiresAndCrossSectionSelection: {
                        get() {
                            return this.$store.state.cables.brakeMonitoringCableNumberOfWiresAndCrossSectionSelection;
                        },
                    },
                    selectedBrakeMonitoringCableNumberOfWiresAndCrossSection: {
                        get() {
                            return this.$store.getters['cables/brakeMonitoringCableNumberOfWiresAndCrossSection'];
                        },
                        set(value) {
                            this.change_Selected_atElementOf_brakeMonitoringCableNumberOfWiresAndCrossSection(value);
                        }
                    },
                    brakeMonitoringCableBlockNumberSelection: {
                        get() {
                            return this.$store.state.cables.brakeMonitoringCableBlockNumberSelection != null
                                && Array.isArray(this.$store.state.cables.brakeMonitoringCableBlockNumberSelection)
                                ? this.$store.state.cables.brakeMonitoringCableBlockNumberSelection
                                : null;
                        },
                    },
                    selectedBrakeMonitoringCableBlockNumber: {
                        get() {
                            return this.$store.getters['cables/selectedBrakeMonitoringCableBlockNumber'];
                        },
                        set(value) {
                            this.change_Selected_atElementOf_brakeMonitoringCableBlockNumberSelection(value);
                        }
                    },
                    brakeMonitoringCableTypeDesignation: {
                        get() {
                            return this.selectedBrakeMonitoringCableBlockNumber != null
                                && this.selectedBrakeMonitoringCableBlockNumber.hasOwnProperty('typeDesignation')
                                ? this.selectedBrakeMonitoringCableBlockNumber.typeDesignation
                                : null;
                        },
                    },
                    // forced ventilation cable
                    forcedVentilationCableDeliverSelection: {
                        get() {
                            return this.$store.state.cables.cables_Data != null
                                && this.$store.state.cables.cables_Data.hasOwnProperty('forcedVentilationCable_DeliverOption_Valuelist')
                                ? this.$store.state.cables.cables_Data.forcedVentilationCable_DeliverOption_Valuelist
                                : [];
                        },
                    },
                    selectedForcedVentilationCableDeliver: {
                        get() {
                            return this.$store.getters['cables/selectedForcedVentilationCableDeliver'];
                        },
                        set(value) {
                            this.change_Selected_atElementOf_forcedVentilationCableDeliver(value);
                        }
                    },
                    forcedVentilationCablesShowDetails: {
                        get() {
                            const valuelist = this.$store.state.cables.cables_Data != null
                                ? this.$store.state.cables.cables_Data.forcedVentilationCable_DeliverOption_Valuelist
                                : null;

                            if (!Array.isArray(valuelist)) {
                                return false;
                            }

                            const selectedItem = valuelist.find(i => i.selected == true);
                            return selectedItem != null ? selectedItem.showDetails : false;
                        },
                    },
                    forcedVentilationCableLengthSelection: {
                        get() {
                            return this.$store.state.cables.forcedVentilationCableLengthSelection;
                        },
                    },
                    selectedForcedVentilationCableLength: {
                        get() {
                            return this.$store.getters['cables/selectedForcedVentilationCableLength'];
                        },
                        set(value) {
                            this.change_Selected_atElementOf_forcedVentilationCableLength(value);
                        }
                    },
                    forcedVentilationCableTypeOfConnectionOnComponentSideSelection: {
                        get() {
                            return this.$store.state.cables.forcedVentilationCableTypeOfConnectionOnComponentSideSelection;
                        },
                    },
                    selectedForcedVentilationCableTypeOfConnectionOnComponentSide: {
                        get() {
                            return this.$store.getters['cables/selectedForcedVentilationCableTypeOfConnectionOnComponentSide'];
                        },
                        set(value) {
                            this.change_Selected_atElementOf_forcedVentilationCableTypeOfConnectionOnComponentSide(value);
                        }
                    },
                    forcedVentilationCableSpecificationSelection: {
                        get() {
                            return this.$store.state.cables.forcedVentilationCableSpecificationSelection;
                        },
                    },
                    selectedForcedVentilationCableSpecification: {
                        get() {
                            return this.$store.getters['cables/selectedForcedVentilationCableSpecification'];
                        },
                        set(value) {
                            this.change_Selected_atElementOf_forcedVentilationCableSpecification(value);
                        }
                    },
                    forcedVentilationCableNumberOfWiresAndCrossSectionSelection: {
                        get() {
                            return this.$store.state.cables.forcedVentilationCableNumberOfWiresAndCrossSectionSelection;
                        },
                    },
                    selectedForcedVentilationCableNumberOfWiresAndCrossSection: {
                        get() {
                            return this.$store.getters['cables/forcedVentilationCableNumberOfWiresAndCrossSection'];

                        },
                        set(value) {
                            this.change_Selected_atElementOf_forcedVentilationCableNumberOfWiresAndCrossSection(value);
                        }
                    },
                    forcedVentilationCableBlockNumberSelection: {
                        get() {
                            return this.$store.state.cables.forcedVentilationCableBlockNumberSelection != null
                                && Array.isArray(this.$store.state.cables.forcedVentilationCableBlockNumberSelection)
                                ? this.$store.state.cables.forcedVentilationCableBlockNumberSelection
                                : null;
                        },
                    },
                    selectedForcedVentilationCableBlockNumber: {
                        get() {
                            return this.$store.getters['cables/selectedForcedVentilationCableBlockNumber'];
                        },
                        set(value) {
                            this.change_Selected_atElementOf_forcedVentilationCableBlockNumberSelection(value);
                        }
                    },
                    forcedVentilationCableTypeDesignation: {
                        get() {
                            return this.selectedForcedVentilationCableBlockNumber != null
                                && this.selectedForcedVentilationCableBlockNumber.hasOwnProperty('typeDesignation')
                                ? this.selectedForcedVentilationCableBlockNumber.typeDesignation
                                : null;
                        },
                    },

                },
                methods: {
                    ValueDecimalSeparator(value) {
                        if (value != null) {
                            const localDecimal = { value: value, country: this.$store.state.configurations.language, }
                            return this.$get_decimalValueToLocaleString(localDecimal);
                        }
                        return value;
                    },

                    change_Selected_atElementOf_encoderCableDeliver(value) {
                        this.$store.dispatch('cables/change_encoderCableDeliver_storeAction', value);
                    },
                    change_Selected_atElementOf_motorCableDeliver(value) {
                        this.$store.dispatch('cables/change_motorCableDeliver_storeAction', value);
                    },
                    change_Selected_atElementOf_motorProtectionCableDeliver(value) {
                        this.$store.dispatch('cables/change_motorProtectionCableDeliver_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeCableDeliver(value) {
                        this.$store.dispatch('cables/change_brakeCableDeliver_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeMonitoringCableDeliver(value) {
                        this.$store.dispatch('cables/change_brakeMonitoringCableDeliver_storeAction', value);
                    },
                    change_Selected_atElementOf_forcedVentilationCableDeliver(value) {
                        this.$store.dispatch('cables/change_forcedVentilationCableDeliver_storeAction', value);
                    },

                    change_Selected_atElementOf_encoderConnectionLength(value) {
                        this.$store.dispatch('cables/change_encoderConnectionLength_storeAction', value);
                    },
                    change_Selected_atElementOf_encoderConnectionCableBlockNumber(value) {
                        this.$store.dispatch('cables/change_encoderConnectionCableBlockNumber_storeAction', value);
                    },
                    change_Selected_atElementOf_encoderCableLength(value) {
                        this.$store.dispatch('cables/change_encoderCableLength_storeAction', value);
                    },
                    change_Selected_atElementOf_motorCableLength(value) {
                        this.$store.commit('cables/changed_userSelectedLengthMotorCable_storeMutation', true);
                        this.$store.dispatch('cables/change_motorCableLength_storeAction', value);
                    },
                    change_Selected_atElementOf_motorProtectionCableLength(value) {
                        this.$store.commit('cables/changed_userSelectedLengthMotorProtectionCable_storeMutation', true);
                        this.$store.dispatch('cables/change_motorProtectionCableLength_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeCableLength(value) {
                        this.$store.commit('cables/changed_userSelectedLengthBrakeCable_storeMutation', true);
                        this.$store.dispatch('cables/change_brakeCableLength_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeMonitoringCableLength(value) {
                        this.$store.commit('cables/changed_userSelectedLengthBrakeMonitoringCable_storeMutation', true);
                        this.$store.dispatch('cables/change_brakeMonitoringCableLength_storeAction', value);
                    },
                    change_Selected_atElementOf_forcedVentilationCableLength(value) {
                        this.$store.commit('cables/changed_userSelectedLengthForcedVentilationCable_storeMutation', true);
                        this.$store.dispatch('cables/change_forcedVentilationCableLength_storeAction', value);
                    },

                    change_Selected_atElementOf_encoderConnectionTypeOfConnectionOnComponentSide(value) {
                        this.$store.dispatch('cables/change_encoderConnectionTypeOfConnectionOnComponentSide_storeAction', value);
                    },
                    change_Selected_atElementOf_encoderCableTypeOfConnectionOnComponentSide(value) {
                        this.$store.dispatch('cables/change_encoderCableTypeOfConnectionOnComponentSide_storeAction', value);
                    },
                    change_Selected_atElementOf_motorCableTypeOfConnectionOnComponentSide(value) {
                        this.$store.dispatch('cables/change_motorCableTypeOfConnectionOnComponentSide_storeAction', value);
                    },
                    change_Selected_atElementOf_motorProtectionCableTypeOfConnectionOnComponentSide(value) {
                        this.$store.dispatch('cables/change_motorProtectionCableTypeOfConnectionOnComponentSide_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeCableTypeOfConnectionOnComponentSide(value) {
                        this.$store.dispatch('cables/change_brakeCableTypeOfConnectionOnComponentSide_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeMonitoringCableTypeOfConnectionOnComponentSide(value) {
                        this.$store.dispatch('cables/change_brakeMonitoringCableTypeOfConnectionOnComponentSide_storeAction', value);
                    },
                    change_Selected_atElementOf_forcedVentilationCableTypeOfConnectionOnComponentSide(value) {
                        this.$store.dispatch('cables/change_forcedVentilationCableTypeOfConnectionOnComponentSide_storeAction', value);
                    },

                    change_Selected_atElementOf_encoderCableSpecification(value) {
                        this.$store.dispatch('cables/change_encoderCableSpecification_storeAction', value);
                    },
                    change_Selected_atElementOf_motorCableSpecification(value) {
                        this.$store.dispatch('cables/change_motorCableSpecification_storeAction', value);
                    },
                    change_Selected_atElementOf_motorProtectionCableSpecification(value) {
                        this.$store.dispatch('cables/change_motorProtectionCableSpecification_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeCableSpecification(value) {
                        this.$store.dispatch('cables/change_brakeCableSpecification_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeMonitoringCableSpecification(value) {
                        this.$store.dispatch('cables/change_brakeMonitoringCableSpecification_storeAction', value);
                    },
                    change_Selected_atElementOf_forcedVentilationCableSpecification(value) {
                        this.$store.dispatch('cables/change_forcedVentilationCableSpecification_storeAction', value);
                    },

                    change_Selected_atElementOf_encoderCableNumberOfWiresAndCrossSection(value) {
                        this.$store.dispatch('cables/change_encoderCableNumberOfWiresAndCrossSection_storeAction', value);
                    },
                    change_Selected_atElementOf_motorCableNumberOfWiresAndCrossSection(value) {
                        this.$store.dispatch('cables/change_motorCableNumberOfWiresAndCrossSection_storeAction', value);
                    },
                    change_Selected_atElementOf_motorProtectionCableNumberOfWiresAndCrossSection(value) {
                        this.$store.dispatch('cables/change_motorProtectionCableNumberOfWiresAndCrossSection_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeCableNumberOfWiresAndCrossSection(value) {
                        this.$store.dispatch('cables/change_brakeCableNumberOfWiresAndCrossSection_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeMonitoringCableNumberOfWiresAndCrossSection(value) {
                        this.$store.dispatch('cables/change_brakeMonitoringCableNumberOfWiresAndCrossSection_storeAction', value);
                    },
                    change_Selected_atElementOf_forcedVentilationCableNumberOfWiresAndCrossSection(value) {
                        this.$store.dispatch('cables/change_forcedVentilationCableNumberOfWiresAndCrossSection_storeAction', value);
                    },

                    change_Selected_atElementOf_encoderCableBlockNumberSelection(value) {
                        this.$store.dispatch('cables/change_encoderCableBlockNumberSelected_storeAction', value);
                    },
                    change_Selected_atElementOf_motorCableBlockNumberSelection(value) {
                        this.$store.dispatch('cables/change_motorCableBlockNumberSelected_storeAction', value);
                    },
                    change_Selected_atElementOf_motorProtectionCableBlockNumberSelection(value) {
                        this.$store.dispatch('cables/change_motorProtectionCableBlockNumberSelected_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeCableBlockNumberSelection(value) {
                        this.$store.dispatch('cables/change_brakeCableBlockNumberSelected_storeAction', value);
                    },
                    change_Selected_atElementOf_brakeMonitoringCableBlockNumberSelection(value) {
                        this.$store.dispatch('cables/change_brakeMonitoringCableBlockNumberSelected_storeAction', value);
                    },
                    change_Selected_atElementOf_forcedVentilationCableBlockNumberSelection(value) {
                        this.$store.dispatch('cables/change_forcedVentilationCableBlockNumberSelected_storeAction', value);
                    },

                    furtherTo() {
                        this.$store.dispatch('cables/checkIf_cablesManual_areValid_storeAction');
                    },
                    furtherToManualHome() {
                        this.$store.dispatch('inputsManual/cancelManualMotorConfiguration_storeAction')
                    },
                },
            }
</script>

<style>
    .my_inputCheckbox2 {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox2 li {
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

    .my_inputCheckbox {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox li {
            display: inline-block;
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

            .my_inputCheckbox li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_inputCheckbox li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }
</style>
